import { FilterOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { useState } from "react";
import TopFilters from "./TopFilters";

const MobileTopFilters = () => {
  const [isShowMobileFilterDrawer, setIsShowMobileFilterDrawer] =
    useState(false);
  return (
    <>
      <MazakaButton
        className="!bg-black !text-white !w-full"
        icon={<FilterOutlined />}
        block
        onClick={() => {
          setIsShowMobileFilterDrawer(true);
        }}
      >
        Filtre
      </MazakaButton>

      <Drawer
        title={"Özet Bilgileri Filtrele"}
        open={isShowMobileFilterDrawer}
        onClose={() => {
          setIsShowMobileFilterDrawer(false);
        }}
      >
        <TopFilters isMobile={true}  />
      </Drawer>
    </>
  );
};

export default MobileTopFilters;
